import fs from 'fs';
import path from 'path';
export default function jsonInjectorPlugin(options?: { path?: string }) {
	const jsonFilePath = path.resolve(options?.path || './vscodeconfig.json'); // 默认路径
	return {
		name: 'vite-plugin-json-injector',
		config() {
			if (!fs.existsSync(jsonFilePath)) {
				console.error(`JSON file not found at: ${jsonFilePath}`);
				return {};
			}
            const jsonData = JSON.parse(fs.readFileSync(jsonFilePath, 'utf-8'));
            return {
                define:{
                    __JSON_CONFIG__: jsonData
                }
            };
		},
		// 添加热更新支持
		handleHotUpdate({ file, server }:{ file: string, server: any}) {
			if (file === jsonFilePath) {
				const jsonData = JSON.parse(fs.readFileSync(jsonFilePath, 'utf-8'));
				// 重新注入数据
				server.ws.send({
					type: 'custom',
					event: 'json-update',
					data: jsonData,
				});
				console.log('JSON file updated:', jsonData);
			}
		}
	}
}

